<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalOutboundItemsFormDetail
    v-if="modalShowOutboundItemsFormDetail"
    @closeModal="closeModal"
    :outboundItemsFormDetail="selectedOutboundItemsFormDetail"
    :parentItemId="$route.params?.id"
  />
  <ModalChooseProduct v-if="modalShowChooseProduct" @closeModal="closeModalProduct" @submit="submitProduct" />
  <IndexView/>
  <ViewContainer>
  <section class="p-6">
    <BackButton class="mb-5" to_url="/outbound-items-form" />
    <PageTitle title="Edit Barang Keluar"/>
    <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500 dark:text-dark-500">
      <InputSelect v-if="currRoleId == 'null'" v-model="outboundItemsForm.outlet_id" id="outlet-id" name="outlet-id" label="Outlet"
        option-label="name" option-value="id"
          :options="allOutlets" placeholder="Pilih Outlet"/>
      <InputRadio
        v-model="outboundItemsForm.form_type" id="form-type" name="form-type" label="Tipe Barang Keluar"
        :options="[{ value: 'scrap', label: 'Scrap' }, { value: 'misc', label: 'Lain-lain' }]"
        :valid="validation.form_type.valid"
        :error-message="validation.form_type.message"
      />
      <InputSelect v-if="outboundItemsForm.form_type == 'misc'" v-model="outboundItemsForm.outbound_from" id="outbound-from" name="outbound-from" label="Tujuan"
        :options="optionOutboundFrom" :valid="validation.outbound_from.valid" :error-message="validation.outbound_from.message" />
      <InputTextAreaCustom 
        v-model="outboundItemsForm.notes" 
        id="item-note" 
        label="Catatan"
        type="text" 
        div_class="w-full"
        @input="outboundItemsForm.isEdit = true"
      />

      <div id="table-header" class="mb-5 mt-5 flex justify-between">
        <AddButton v-if="outboundItemsForm.status != 'paid'" to_url="#" button_text="Pilih Item"
          button_class="text-base py-2 font-medium" @click="showModalProduct" />
      </div>

      <div class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <TableComponent>
              <TableHead>
                <TableRow>
                  <TableHeadCell>No</TableHeadCell>
                  <TableHeadCell>Status</TableHeadCell>
                  <TableHeadCell>Action</TableHeadCell>
                  <TableHeadCell>Kode Item</TableHeadCell>
                  <TableHeadCell>Nama Item</TableHeadCell>
                  <TableHeadCell numeric>Stok Saat Ini</TableHeadCell>
                  <TableHeadCell numeric>Qty</TableHeadCell>
                  
                  <TableHeadCell>Catatan</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow v-if="outboundItemsFormDetails?.length == 0">
                  <TableCell colspan="7" customClass="text-center italic text-gray-400 dark:text-gray-500"
                    noTextColor>
                    Belum ada data
                  </TableCell>
                </TableRow>
                <TableRow v-else v-for="(outboundItemsFormDetail, index) in outboundItemsFormDetails" :key="outboundItemsFormDetail.id" :index="index"
                    isBody>
                  <TableCell>{{ index + 1 }}</TableCell>
                  <TableCell>
                    <div class="justify-center items-center text-gray-500 dark:text-gray-400 flex" v-if="outboundItemsForm.status != 'paid'">
                      <button v-if="outboundItemsFormDetail.isEdit" :id="'edit-data-' + outboundItemsFormDetail.id"
                        @click="submitOutboundItemsFormDetail(outboundItemsFormDetail)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <ArrowDownTrayIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'delete-data-' + outboundItemsFormDetail.id"
                        @click="deleteOutboundItemsFormDetail(outboundItemsFormDetail)"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button>
                    </div>
                  </TableCell>
                  <TableCell>
                    <span :class="{
                        'bg-red-500 dark:bg-red-500 text-light-50 dark:text-white': outboundItemsFormDetail.isEdit,
                        'bg-green-500 dark:bg-green-500 text-white dark:text-white': !outboundItemsFormDetail.isEdit
                      }" class="px-2 py-1 rounded-full text-sm font-medium">
                      {{ outboundItemsFormDetail.isEdit ? 'Belum Disimpan' : 'Tersimpan' }}
                    </span>
                  </TableCell>
                  <TableCell>{{ outboundItemsFormDetail.items?.code }}</TableCell>
                  <TableCell>{{ outboundItemsFormDetail.items?.name }}</TableCell>
                  <TableCell numeric>{{ outboundItemsFormDetail.items?.stockMovements.length > 0 ? outboundItemsFormDetail.items?.stockMovements[0].closing_balance : 0 }}</TableCell>
                  <TableCell>
                    <div v-if="outboundItemsForm.status != 'paid'" class="flex items-center rounded-lg p-1">
                      <button @click="reduceItem(outboundItemsFormDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                        <MinusCircleIcon class="h-5 w-5" />
                      </button>
                      <InputTextCustom v-model="outboundItemsFormDetail.qty" id="item-min-qty-per-unit" type="number" div_class="w-20" min="1" @input="inputQty(outboundItemsFormDetail)"/>
                      <button @click="addItem(outboundItemsFormDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                        <PlusCircleIcon class="h-5 w-5" />
                        </button>
                    </div>
                    <div v-else>
                      {{ outboundItemsFormDetail.qty }}
                    </div>
                  </TableCell>
                  <TableCell>
                    <InputTextAreaCustom 
                      v-model="outboundItemsFormDetail.note" 
                      id="item-note" 
                      type="text" 
                      div_class="w-full"
                      @input="outboundItemsFormDetail.isEdit = true"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableComponent>
          </div>
        </div>
      </div>

      <div class="flex justify-center gap-3 mt-5" v-if="outboundItemsForm.status != 'paid'">
        <Button type="submit" label="Simpan" :loading="loading" @click="submitOutboundItemsForm" />
        <Button type="submit" label="Posting" :loading="loading" @click="submitCloseOutboundItemsForm" />
      </div>
      <div class="flex justify-center" v-if="outboundItemsForm.status == 'paid'">
        Sudah Diposting
      </div>
    </div>
  </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputRadio from '@/components/form/InputRadio.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import AddButton from "@/components/buttons/AddButton.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import ModalOutboundItemsFormDetail from '@/components/modals/ModalOutboundItemsFormDetail.vue';
import { TrashIcon,ArrowDownTrayIcon, PlusCircleIcon, MinusCircleIcon } from "@heroicons/vue/24/solid";
import ModalChooseProduct from '@/components/modals/ModalChooseProduct.vue';
import ViewContainer from '@/components/ViewContainer.vue';
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
import InputSelect from '@/components/form/InputSelect.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, InputRadio, Button, ConfirmDialog, Toast,
    AddButton, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell,
    ModalOutboundItemsFormDetail, TrashIcon, ModalChooseProduct, ViewContainer, PlusCircleIcon, MinusCircleIcon, ArrowDownTrayIcon, InputTextCustom, InputTextAreaCustom, InputSelect
  },
  data() {
    return {
      loading: false,
      currRoleId: localStorage.getItem('role_id'),
      outboundItemsForm: {
        form_type: null,
        outbound_from: null,
        notes: null,
      },
      outboundItemsFormDetails: [],
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
        outbound_from: {
          valid: true,
          message: ''
        },
      },
      validationDetail: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      field: ['item_id', 'qty'],
      modalShowOutboundItemsFormDetail: false,
      isBlur: false,
      selectedOutboundItemsFormDetail: null,
      modalShowChooseProduct: false,
    }
  },
  async created() {
    await this.fetchOutboundItemsForm();
    await this.fetchOutboundItemsFormDetails();
    await this.$store.dispatch('outlets/fetchOutlets');
  },
  computed: {
    ...mapGetters('outlets', ['allOutlets']),
    optionOutboundFrom() {
      return [
        { label: 'Tester', value: 'tester' },
        { label: 'Pabrik', value: 'pabrik' },
        ...this.allOutlets.map(outlet => ({
          label: outlet.name,
          value: outlet.name,
        })),
      ];
    },
  },
  methods: {
    ...mapActions('outbound_items_forms', ['updateOutboundItemsForm', 'closeOutboundItemsForm']),
    ...mapActions('outbound_items_form_details', ['deleteOutboundItemsFormDetailById', 'createOutboundItemsFormDetail', 'updateOutboundItemsFormDetail']),
    async fetchOutboundItemsForm() {
      const response = await this.$store.dispatch('outbound_items_forms/fetchOutboundItemsFormById', this.$route.params.id);
      this.outboundItemsForm = response.data;
    },
    async fetchOutboundItemsFormDetails() {
      const response = await this.$store.dispatch('outbound_items_form_details/fetchOutboundItemsFormDetails', { outbound_items_form_id: this.$route.params.id, limit: 1000 });
      if (response) {
        this.outboundItemsFormDetails = response.data;
      } else {
        this.outboundItemsFormDetails = [];
      }
    },
    addItem(item) {
      const existingItemIndex = this.outboundItemsFormDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.outboundItemsFormDetails[existingItemIndex].qty = Number(this.outboundItemsFormDetails[existingItemIndex].qty) + 1;
        this.outboundItemsFormDetails[existingItemIndex].isEdit = true;
      }
    },
    reduceItem(item) {
      const existingItemIndex = this.outboundItemsFormDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.outboundItemsFormDetails[existingItemIndex].qty = Number(this.outboundItemsFormDetails[existingItemIndex].qty) > 1 ? Number(this.outboundItemsFormDetails[existingItemIndex].qty) - 1 : 1;
        this.outboundItemsFormDetails[existingItemIndex].isEdit = true;
      }
    },
    inputQty(item) {
      item.isEdit = true;
      item.qty = Number(item.qty) <= 0 ? 1 : item.qty;
    },
    submitOutboundItemsForm() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postOutboundItemsForm();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft barang masuk', life: 3000 });
        }
      });
    },
    async postOutboundItemsForm() {
      try {
        this.loading = true;
        const outboundItemsFormData = {
          form_type: this.outboundItemsForm.form_type == "scrap" ? "scrap" : "misc",
          id: this.$route.params.id,
          outbound_from: this.outboundItemsForm.outbound_from,
          notes: this.outboundItemsForm.notes,
          outlet_id: this.outboundItemsForm.outlet_id,
        };

        const isEdit = this.outboundItemsFormDetails.filter(detail => detail.isEdit);

        if (isEdit.length > 0) {
          await this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Ada detail yang diubah. Harap simpan perubahan terlebih dahulu.', life: 3000 });
          return;
        }

        for await (const item of this.outboundItemsFormDetails) {
          await this.updateOutboundItemsFormDetail(item);
        }

        await this.updateOutboundItemsForm(outboundItemsFormData);
        await this.fetchOutboundItemsForm();

        // if (this.isEdit && this.outboundItemsForm) {
        //   outboundItemsFormData.id = this.outboundItemsForm.id;
        //   await this.updateOutboundItemsForm(outboundItemsFormData);
        // }
        // else {
        //   await this.createOutboundItemsForm(outboundItemsFormData);
        // }

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Barang Keluar telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save outbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    submitCloseOutboundItemsForm() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin posting barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postCloseOutboundItemsForm();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan posting barang masuk', life: 3000 });
        }
      });
    },
    async postCloseOutboundItemsForm() {
      try {
        this.loading = true;
        const outboundItemsFormDataUpdate = {
          form_type: this.outboundItemsForm.form_type == "scrap" ? "scrap" : "misc",
          id: this.$route.params.id,
          outbound_from: this.outboundItemsForm.outbound_from,
          notes: this.outboundItemsForm.notes,
          outlet_id: this.outboundItemsForm.outlet_id,
        };

        const outboundItemsFormData = {
          transaction_id: this.$route.params.id,
          notes: this.outboundItemsForm.notes,
        };

        const isEdit = this.outboundItemsFormDetails.filter(detail => detail.isEdit);

        if (isEdit.length > 0) {
          await this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Ada detail yang diubah. Harap simpan perubahan terlebih dahulu.', life: 3000 });
          return;
        }

        // for await (const item of this.outboundItemsFormDetails) {
        //   await this.updateOutboundItemsFormDetail(item);
        // }

        await this.updateOutboundItemsForm(outboundItemsFormDataUpdate);
        await this.closeOutboundItemsForm(outboundItemsFormData);
        await this.fetchOutboundItemsForm();

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Barang Keluar telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save outbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },

    editOutboundItemsFormDetail(outboundItemsFormDetail) {
      this.selectedOutboundItemsFormDetail = outboundItemsFormDetail;
      this.modalShowOutboundItemsFormDetail = true;
      this.isBlur = true;
    },
    async deleteOutboundItemsFormDetail(table) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus detail?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.deleteOutboundItemsFormDetailById(table.id);
            this.fetchOutboundItemsFormDetails();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus detail', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus detail', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus detail', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus detail', life: 3000 });
        }
      });
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },
    showModal() {
      this.modalShowOutboundItemsFormDetail = true;
      this.isBlur = true;
      this.selectedOutboundItemsFormDetail = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowOutboundItemsFormDetail = false;
        this.isBlur = false;
        this.fetchOutboundItemsFormDetails();
      }, 200);
    },
    showModalProduct() {
      this.modalShowChooseProduct = true;
      this.isBlur = true;
    },
    closeModalProduct() {
      setTimeout(() => {
        this.modalShowChooseProduct = false;
        this.isBlur = false;
        this.fetchOutboundItemsFormDetails();
      }, 200);
    },
    async submitProduct(items) {
      try {
        for await (const item of items) {
          const outboundItemsFormDetailData = {
            outbound_items_form_id: this.$route.params.id,
            item_id: item.id,
          };

          const existingItem = this.outboundItemsFormDetails.find(detail => detail.item_id === item.id);

          if (existingItem) {
            outboundItemsFormDetailData.id = existingItem.id;
            await this.updateOutboundItemsFormDetail(outboundItemsFormDetailData);
          }
          else {
            outboundItemsFormDetailData.qty = 0;
            await this.createOutboundItemsFormDetail(outboundItemsFormDetailData);
          }
        }

        this.closeModalProduct();
        this.fetchOutboundItemsFormDetails();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    submitOutboundItemsFormDetail(item) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postOutboundItemsFormDetail(item);
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
    async postOutboundItemsFormDetail(item) {
      try {
        const outboundItemsFormDetailData = {
          outbound_items_form_id: this.$route.params.id,
          item_id: item.item_id,
          qty: item.qty,
          notes: item.note,
        };

        if (item.id) {
          outboundItemsFormDetailData.id = item.id;
          await this.updateOutboundItemsFormDetail(outboundItemsFormDetailData);
        }

        // Update the item in the array and set isEdit to false
        this.outboundItemsFormDetails = this.outboundItemsFormDetails.map(detail => {
          if (detail.id === item.id) {
            return { ...item, isEdit: false };
          }
          return detail;
        });
        
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrorsDetail(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrorsDetail(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validationDetail[this.field[index]].valid = true;
        this.validationDetail[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validationDetail[error.field]) {
          this.validationDetail[error.field].valid = false;
          this.validationDetail[error.field].message = error.message;
        }
      });
    }
  },
}
</script>